import type { SettingMetadata } from "../../settings-catalog/types";
import { ShippingFulfillmentPromiseFlatTeamSettingCatalogDefinitions as originalDefinitions } from "./catalog";

export const ShippingFulfillmentPromiseFlatTeamSettingCatalogDefinitions =
  originalDefinitions.map((definition) => {
    if (definition.id === "outboundLabels/fulfillmentPromiseDays") {
      return {
        ...definition,
        groupId: "shipping_fulfillment_promise.promise_days" as const,
      };
    }
    return {
      ...definition,
      metadata: {
        ...definition.metadata,
        label: "Use a custom schedule",
        searchLabels: [
          "Timezone for fulfillment cutoff times",
          "Working days & cutoffs",
          "Cutoff time",
          "Sunday",
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday",
          "Saturday",
        ],
      },
    };
  });

export const ShippingFulfillmentPromiseFlatTeamSettingMetadataByKey =
  Object.fromEntries(
    ShippingFulfillmentPromiseFlatTeamSettingCatalogDefinitions.map(
      (definition) => [definition.id, definition.metadata],
    ),
  ) as Record<(typeof originalDefinitions)[number]["id"], SettingMetadata>;
